  <!--
  <div class="bg" style="background-image: linear-gradient(rgba(88, 97, 224, 0.4), rgba(27, 68, 203, 0.8)), url(../assets/fondo.png); text-shadow: 1px 1px 1px #000;">
  -->
  <div class="bg" style="text-shadow: 1px 1px 1px #000;">


  <section class="hero is-fullheight" >
    <div class="hero-body">

      <div class="container has-text-centered">

        <div class="column is-4 is-offset-4">

          <h3 class="title has-text-white is-size-4-mobile"></h3>
          <p class="subtitle has-text-white is-size-2-mobile">{{configuracion.empresa.nombre}}</p>
          <div class="box">

            <figure class="avatar">
             <!--
              <img [src]="configuracion.empresa.logo != '' ? API_PATH + '/adjunto/configuracion/' + configuracion.empresa.logo : '/assets/configuracion-logo.png'"
                alt="Logo">
            -->
            <img src="/assets/account-gray-big.jpg"
                alt="Logo">
            </figure>
            <form name="form" (ngSubmit)="!loading && login()">
              <div class="notification is-danger" *ngIf="mostrarMensaje">
                <a class="delete" (click)="mostrarMensaje = false"></a>
                <b>Error:</b> {{ mensaje }}
              </div>
              <div class="field">
                <p class="control has-icon">
                  <input class="input is-medium" [ngClass]="{'is-danger': mensaje}" type="text" placeholder="Usuario o Correo electrónico"
                    [(ngModel)]="credenciales.email" autofocus [ngModelOptions]="{standalone: true}">
                  <span class="icon is-small is-right">
                    <i class="icon-id-card2"></i>
                  </span>
                </p>
              </div>

              <div class="field">
                <p class="control has-icon">
                  <input class="input is-medium" [ngClass]="{'is-danger': mensaje}" type="password" placeholder="Contraseña" [(ngModel)]="credenciales.password"
                    [ngModelOptions]="{standalone: true}">
                  <span class="icon is-small is-right">
                    <i class="icon-padlock"></i>
                  </span>
                </p>
              </div>
              <p class="control">
                <button class="button is-primary is-large is-fullwidth" [ngClass]="{'is-loading': loading}">Iniciar sesión</button>
              </p>
              <p class="control" *ngIf="oauth_disponible">
                <button class="button is-danger is-large is-fullwidth">Conectar con YourSoft</button>
              </p>
            </form>
          </div>

        </div>
      </div>
    </div>

    <footer class="footer" style="background: transparent;">
      <div class="hero" >
        <p class="has-text-centered">
            Manager Escolar <small>1.0</small>
        </p>
      </div>
    </footer> 

  </section>


</div>
